//Nav-Animation

document.addEventListener('DOMContentLoaded', function () {
  console.log('[SVD] script loaded');

  const body = document.body;
  const logoWrapper = document.querySelector('.site-header_logo');
  const logoText = document.querySelector('p.logo_text');

  console.log('[SVD] logoWrapper found:', !!logoWrapper);
  console.log('[SVD] logoText found:', !!logoText);

  if (!logoWrapper) return;

  const topLock = 80;
  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', function () {
    const currentScrollY = window.scrollY;

    // Debug: zeigt, ob scroll überhaupt feuert
    console.log('[SVD] scrollY:', currentScrollY);

    if (currentScrollY <= topLock) {
      body.classList.remove('header-scrolled');
      logoWrapper.classList.remove('header-scrolled');
      if (logoText) logoText.classList.remove('scrolled');
      lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY > lastScrollY) {
      body.classList.add('header-scrolled');
      logoWrapper.classList.add('header-scrolled');
      if (logoText) logoText.classList.add('scrolled');
    } else if (currentScrollY < lastScrollY) {
      body.classList.remove('header-scrolled');
      logoWrapper.classList.remove('header-scrolled');
      if (logoText) logoText.classList.remove('scrolled');
    }

    lastScrollY = currentScrollY;
  }, { passive: true });
});

